import styled from 'styled-components';

export const NotificationContainer = styled.div`
    padding-inline: 15px;
`

export const NotificationCard = styled.div`
    background-color: ${({theme}) => theme.colors.primary};
    padding: 15px;
    /* min-height: 80vh; */
    border: 1px solid ${({theme}) => theme.colors.link.text};
    margin-block: 10px;
`